import * as Yup from 'yup';

export  const PacienteSchema = Yup.object().shape({
  nombre: Yup.string().required('El nombre es requerido'),
  apellidos: Yup.string().required('Los apellidos son requeridos'),
  cedula: Yup.string().required('La cédula es requerida'),
  email: Yup.string().email('Email inválido').required('El email es requerido'),
  genero: Yup.string().required('El género es requerido'),
  lugar_nacimiento: Yup.string().required('El lugar de nacimiento es requerido'),
  direccion: Yup.string().required('La dirección es requerida'),
  celular: Yup.string().required('El celular es requerido'),
  edad: Yup.string().required('La edad es requerida'),
  fecha_nacimiento: Yup.string().required('La fecha de nacimiento es requerida'),
  medico_cabecera: Yup.string().required('El médico de cabecera es requerido'),
  contacto_emergencia_nombre: Yup.string().required('El nombre del contacto de emergencia es requerido'),
  contacto_emergencia_celular: Yup.string().required('El celular del contacto de emergencia es requerido'),
  contacto_emergencia_parentesco: Yup.string().required('El parentesco del contacto de emergencia es requerido'),
});